export default __webpack_public_path__ + "static/media/project-4.bf1c96e2.jpg";